<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g>
    <rect width="32" height="32" fill="none"/>
    <g>
      <path class="filled" d="M13.219,4.257,1.939,23.8A3.212,3.212,0,0,0,4.72,28.613H27.281A3.212,3.212,0,0,0,30.062,23.8L18.781,4.257A3.211,3.211,0,0,0,13.219,4.257Z" fill="#035ce0"/>
      <rect class="cutout" x="14.2" y="10.817" width="3.6" height="6.244" fill="#fff"/>
      <rect class="cutout" x="14.2" y="20.761" width="3.6" height="4.022" fill="#fff"/>
    </g>
  </g>
</svg>
